var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4265 0.293437C13.8092 0.684062 13.8092 1.31531 13.4265 1.70594L5.5898 9.70593C5.20714 10.0966 4.58878 10.0966 4.20612 9.70593L0.286898 5.70593C-0.0956327 5.31531 -0.0956327 4.68406 0.286898 4.29343C0.66949 3.90281 1.28969 3.90281 1.67235 4.29343L4.87041 7.58406L12.0429 0.293437C12.4255 -0.0978124 13.0439 -0.0978124 13.4265 0.293437Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.4f29a4784d99ed9ea5d78500ac21d875.svg";
export { ForwardRef as ReactComponent };